import { action } from '@play-co/replicant';
import createActions from '../config/actions/createActions';

import { incrementTodayCounter, initTodayCounter } from './analytics.modifiers';

export default createActions({
  updateAbsoluteRevenueSequence: action(
    (state, args: { revenueType: string; feature: string }) => {
      const sequenceByFeature =
        args.revenueType === 'in_app_purchase'
          ? state.analytics.sequences.iapSequenceByFeature
          : state.analytics.sequences.adsSequenceByFeature;

      // Property might not exist
      sequenceByFeature[args.feature] =
        (sequenceByFeature[args.feature] || 0) + 1;
    },
  ),
  updatePurchaseAnalytics: action(
    (
      state,
      args: {
        purchaseTime: number;
        purchaseAction: 'start' | 'end' | 'tapped' | 'failure' | 'success';
        feature: string;
      },
    ) => {
      const purchase = state.analytics.purchases[args.purchaseAction];
      const feature = args.feature;

      if (!purchase) {
        throw new Error('Invalid replicant purchase analytics type');
      }

      purchase.absolute++;
      incrementTodayCounter(args.purchaseTime, purchase.today);

      purchase.absoluteByFeature[feature] =
        (purchase.absoluteByFeature[feature] || 0) + 1;

      if (purchase.todayByFeature[feature]) {
        incrementTodayCounter(
          args.purchaseTime,
          purchase.todayByFeature[feature],
        );
      } else {
        purchase.todayByFeature[feature] = initTodayCounter(args.purchaseTime);
      }
    },
  ),

  updateCancelledAnalytics: action(
    (
      state,
      args: {
        featureKey: string;
        timeNow: number;
      },
    ) => {
      const purchaseAnalytics = state.analytics.purchases;
      const featureKey = args.featureKey;

      purchaseAnalytics.cancelledFeature[featureKey] =
        (purchaseAnalytics.cancelledFeature[featureKey] || 0) + 1;

      incrementTodayCounter(args.timeNow, purchaseAnalytics.cancelledToday);
    },
  ),

  resetCancelledAnalytics: action(
    (
      state,
      args: {
        featureKey: string;
        timeNow: number;
      },
    ) => {
      const purchaseAnalytics = state.analytics.purchases;
      const featureKey = args.featureKey;

      delete purchaseAnalytics.cancelledFeature[featureKey];
      purchaseAnalytics.cancelledToday = initTodayCounter(args.timeNow, 0);
    },
  ),

  setSchemaVersion: action(
    (
      state,
      args: {
        version: string;
      },
    ) => {
      state.analytics.purchases.schemaVersion = args.version;
    },
  ),
});
